import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { ref: "canvas" }
const _hoisted_2 = { id: "backgrounds" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "file-input",
  for: "file"
}, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "17",
      viewBox: "0 0 20 17"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" })
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("canvas", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: "clear",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.background.removeAttribute('src')))
      }, "X"),
      _createElementVNode("input", {
        id: "file",
        type: "file",
        accept: "video/mp4,video/x-m4v,video/*",
        style: {"display":"none"},
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onUploadBackground && _ctx.onUploadBackground(...args)))
      }, null, 32),
      _hoisted_3,
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgrounds, (src, index) => {
        return (_openBlock(), _createElementBlock("video", {
          key: index,
          src: src,
          onClick: ($event: any) => (_ctx.background.src = src)
        }, null, 8, _hoisted_5))
      }), 128))
    ])
  ], 64))
}